// src/components/viewer/ViewerHeader.jsx

import React from 'react';

const ViewerHeader = ({ requestId }) => {
    return (
        <div className="viewer-header">
            <h1>📊 My Requests</h1>
            <p>Track your access requests and view validation results</p>
            <div className="request-id">
                {requestId ? `Request ID: ${requestId}` : 'Loading...'}
            </div>
        </div>
    );
};

export default ViewerHeader;